import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
`;

export const PanelContainer = styled.div`
  height: ${({ mobileHeight }) =>
    mobileHeight
      ? `calc(100vh - ${mobileHeight}px - var(--header-height))`
      : '500px'};
  overflow: hidden;
  margin: 0;
  padding: 0;
  padding-bottom: 22px;

  ${QUERIES.tabletAndUp} {
    height: 500px;
    padding-bottom: 0;
  }
`;

export const PanelWrapper = styled.ul`
  height: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
  scrollbar-width: thin;
  scroll-behavior: smooth;
  scrollbar-color: ${themeStyle.varInkLight};

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px ${themeStyle.varInkLight};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${themeStyle.varInkMedium};
  }
  overflow-x: hidden;
`;

export const Loader = styled.div`
  height: 10px;
  width: 100%;
`;
